import { SET_STORED_PARENT_DEALER_ACCOUNT_ID } from "../action";
import { getStoredParentDealerIds } from "../api/api.js";

export function fetchStoredParentDealerAccountDetails() {
  return (dispatch) => {
    return getStoredParentDealerIds().then((data) => {
      dispatch({ type: SET_STORED_PARENT_DEALER_ACCOUNT_ID, payload: data });
    });
  };
}
